import React, { useCallback } from 'react';

export function useReactElementTransformers(
  transformers: Array<
    (el: HTMLElement, children: React.ReactNode) => React.ReactNode
  >,
) {
  return useCallback(
    (element: HTMLElement, children: React.ReactNode) => {
      for (const transformer of transformers) {
        const value = transformer(element, children);
        if (value) {
          return value;
        }
      }
      return null;
    },
    [transformers],
  );
}
